import { SweetFaceEmployeeDto } from './sweet-face-employee.dto';
import { SweetFacePagedResponse } from './sweet-face-paged-response';

export class GetSweetFaceEmployeesResponseDto extends SweetFacePagedResponse<SweetFaceEmployeeDto> {}
